// Cart Drawer Personnalisé - Design original avec réouverture automatique + rafraîchissement à la fermeture
(function() {
document.addEventListener('DOMContentLoaded', function() {
console.log('Cart Drawer Personnalisé chargé');

// 1. DÉSACTIVER UNIQUEMENT LE CART DRAWER EXISTANT
const style = document.createElement('style');
style.textContent = `
  /* Désactiver uniquement les cart drawers Shopify */
  cart-drawer, .cart-drawer, #CartDrawer, [data-cart-drawer] {
    display: none !important;
    visibility: hidden !important;
    opacity: 0 !important;
  }
`;
document.head.appendChild(style);

// 2. INTERCEPTER LES AJOUTS AU PANIER DEPUIS LES FORMULAIRES
document.addEventListener('submit', function(e) {
  if (e.target.matches('form[action="/cart/add"]') || e.target.matches('form[action*="/cart/add"]')) {
    e.preventDefault();
    
    const formData = new FormData(e.target);
    
    fetch('/cart/add.js', {
      method: 'POST',
      body: formData
    })
    .then(response => response.json())
    .then(data => {
      console.log('Produit ajouté au panier:', data);
      return fetch('/cart.js');
    })
    .then(response => response.json())
    .then(cart => {
      const cartCountElements = document.querySelectorAll('.cart-count-bubble, .cart-count, [data-cart-count], .cart-icon span');
      cartCountElements.forEach(element => {
        if (element.textContent !== undefined) {
          element.textContent = cart.item_count;
        }
      });
      
      openCustomCartDrawer();
    })
    .catch(error => {
      console.error('Erreur lors de l\'ajout au panier:', error);
    });
  }
});

// 3. INTERCEPTER LES CLICS SUR L'ICÔNE PANIER
document.addEventListener('click', function(e) {
  const cartButton = e.target.closest('[data-cart-count], .cart-icon, .cart-count-bubble, a[href="/cart"], [data-action="open-drawer"]');
  if (cartButton) {
    e.preventDefault();
    e.stopPropagation();
    openCustomCartDrawer();
  }
});

// 4. FONCTION POUR OUVRIR LE CART DRAWER PERSONNALISÉ
function openCustomCartDrawer() {
  fetch('/cart.js')
    .then(response => response.json())
    .then(cart => {
      createCustomCartDrawer(cart);
    })
    .catch(error => {
      console.error('Erreur lors de la récupération du panier:', error);
      createCustomCartDrawer({ items: [], item_count: 0, total_price: 0 });
    });
}

// 5. FONCTION POUR DÉTECTER SI ON EST SUR MOBILE
function isMobile() {
  return window.innerWidth <= 768;
}

// 6. FONCTION POUR CRÉER LE CART DRAWER PERSONNALISÉ
async function createCustomCartDrawer(cart) {
  console.log('Création du cart drawer, panier:', cart);
  
  // Supprimer le cart drawer existant s'il y en a un
  const existingDrawer = document.querySelector('.custom-cart-drawer');
  if (existingDrawer) {
    document.body.removeChild(existingDrawer);
  }
  
  const existingOverlay = document.querySelector('.custom-cart-overlay');
  if (existingOverlay) {
    document.body.removeChild(existingOverlay);
  }
  
  // Calculer les données pour la livraison offerte avec seuil à 30€
  const cartTotal = cart.total_price / 100;
  const freeShippingThreshold = 20;
  const freeShippingRemaining = Math.max(freeShippingThreshold - cartTotal, 0);
  const progressPercentage = Math.min((cartTotal / freeShippingThreshold) * 100, 100);
  
  // Variables responsives
  const mobile = isMobile();
  const drawerWidth = mobile ? '100vw' : '450px';
  const headerPadding = mobile ? '15px' : '20px';
  const itemImageSize = mobile ? '60px' : '80px';
  const bestsellerImageSize = mobile ? '50px' : '70px';
  const itemPadding = mobile ? '15px' : '20px';
  const fontSize = mobile ? '14px' : '16px';
  const titleFontSize = mobile ? '14px' : '16px';
  const priceFontSize = mobile ? '14px' : '16px';
  
  // Best-sellers avec URL Cryo Patch corrigée
  const bestsellerProducts = [
    {
      id: '9440516112712',
      title: 'Cryo Patch',
      price: '16,90€',
      oldPrice: '20,00€',
      image: 'https://cdn.shopify.com/s/files/1/0895/1129/7352/files/7.png?v=1745014968',
      available: true,
      url: '/products/cryo-patch-migraine'
    },
    {
      id: '9442756133192',
      title: 'Cryo Roller',
      price: '22,90€',
      oldPrice: '30,00€',
      image: 'https://cdn.shopify.com/s/files/1/0895/1129/7352/files/cryolia_3.png?v=1745014300',
      available: true,
      url: '/products/cryo-roller'
    },
    {
      id: '9442752168264',
      title: 'Cryo Coussin',
      price: '22,90€',
      oldPrice: '30,00€',
      image: 'https://cdn.shopify.com/s/files/1/0895/1129/7352/files/ChatGPT_Image_16_avr._2025_20_23_10.png?v=1744827941',
      available: true,
      url: '/products/cryo-coussin'
    }
  ];
  
  // Filtrage renforcé
  const cartProductIds = [];
  if (cart.items && cart.items.length > 0) {
    cart.items.forEach(item => {
      cartProductIds.push(item.variant_id.toString());
      if (item.product_id) {
        cartProductIds.push(item.product_id.toString());
      }
      if (item.id) {
        cartProductIds.push(item.id.toString());
      }
    });
  }
  
  const availableBestsellers = bestsellerProducts.filter(product => {
    const isInCart = cartProductIds.includes(product.id);
    return !isInCart && product.available;
  });
  
  // Générer le HTML des produits dans le panier
  let cartItemsHTML = '';
  if (cart.items && cart.items.length > 0) {
    cart.items.forEach((item, index) => {
      const itemPrice = (item.final_line_price / 100).toFixed(2).replace('.', ',') + '€';
      const itemImage = item.image || `/placeholder.svg?height=${itemImageSize.replace('px', '')}&width=${itemImageSize.replace('px', '')}`;
      const lineNumber = item.line || (index + 1);
      
      cartItemsHTML += `
        <div style="display: flex; gap: ${mobile ? '10px' : '15px'}; align-items: center; margin-bottom: ${mobile ? '15px' : '20px'}; padding-bottom: ${mobile ? '15px' : '20px'}; border-bottom: 1px solid #e9ecef;">
          <div style="width: ${itemImageSize}; height: ${itemImageSize}; background: #f1f3f4; border-radius: 6px; overflow: hidden; flex-shrink: 0;">
            <img src="${itemImage}" alt="${item.title}" style="width: 100%; height: 100%; object-fit: cover;">
          </div>
          <div style="flex: 1; min-width: 0;">
            <h3 style="margin: 0 0 ${mobile ? '3px' : '5px'} 0; font-size: ${titleFontSize}; font-weight: 600; color: #333; line-height: 1.2; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">${item.product_title}</h3>
            ${item.variant_title ? `<p style="margin: 0 0 ${mobile ? '6px' : '10px'} 0; color: #666; font-size: ${mobile ? '12px' : '14px'}; line-height: 1.2; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">${item.variant_title}</p>` : ''}
            <div style="display: flex; align-items: center; gap: ${mobile ? '6px' : '10px'};">
              <div style="display: flex; align-items: center; border: 1px solid #ddd; border-radius: 4px;">
                <button onclick="window.updateCartQuantity(${lineNumber}, ${item.quantity - 1})" style="background: none; border: none; padding: ${mobile ? '4px 8px' : '8px 12px'}; cursor: pointer; font-size: ${mobile ? '14px' : '16px'}; color: #666;">−</button>
                <span style="padding: ${mobile ? '4px 8px' : '8px 12px'}; font-weight: 500; min-width: ${mobile ? '30px' : '40px'}; text-align: center; font-size: ${mobile ? '12px' : '14px'};">${item.quantity}</span>
                <button onclick="window.updateCartQuantity(${lineNumber}, ${item.quantity + 1})" style="background: none; border: none; padding: ${mobile ? '4px 8px' : '8px 12px'}; cursor: pointer; font-size: ${mobile ? '14px' : '16px'}; color: #666;">+</button>
              </div>
            </div>
          </div>
          <div style="text-align: right; flex-shrink: 0;">
            <p style="margin: 0 0 ${mobile ? '3px' : '5px'} 0; font-size: ${priceFontSize}; font-weight: 600; color: #333;">${itemPrice}</p>
            <button onclick="window.updateCartQuantity(${lineNumber}, 0)" style="background: none; border: none; cursor: pointer; color: #999; font-size: ${mobile ? '16px' : '18px'}; display: flex; align-items: center; justify-content: center;">
              <svg width="${mobile ? '16' : '18'}" height="${mobile ? '16' : '18'}" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <polyline points="3 6 5 6 21 6"></polyline>
                <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>
                <line x1="10" y1="11" x2="10" y2="17"></line>
                <line x1="14" y1="11" x2="14" y2="17"></line>
              </svg>
            </button>
          </div>
        </div>
      `;
    });
  } else {
    cartItemsHTML = `
      <div style="text-align: center; padding: ${mobile ? '30px 15px' : '40px 20px'};">
        <p style="font-size: ${fontSize}; color: #666; margin-bottom: ${mobile ? '15px' : '20px'};">Votre panier est vide</p>
        <a href="/collections/all" style="display: inline-block; background: #333; color: white; padding: ${mobile ? '10px 20px' : '12px 24px'}; border-radius: 6px; text-decoration: none; font-weight: 500; font-size: ${mobile ? '14px' : '16px'};">Continuer vos achats</a>
      </div>
    `;
  }
  
  // Générer le HTML des best-sellers
  let bestsellersHTML = '';
  if (availableBestsellers.length > 0) {
    availableBestsellers.forEach((product, index) => {
      const buttonId = `upsell-btn-${product.id}-${Date.now()}`;
      bestsellersHTML += `
        <div class="bestseller-item" data-variant-id="${product.id}" data-product-url="${product.url}" style="min-width: 100%; display: flex; align-items: center; justify-content: center; gap: ${mobile ? '10px' : '15px'}; padding: 0 ${mobile ? '35px' : '40px'}; box-sizing: border-box;">
          <div class="bestseller-image clickable-area" data-url="${product.url}" style="width: ${bestsellerImageSize}; height: ${bestsellerImageSize}; background: #f1f3f4; border-radius: 6px; overflow: hidden; flex-shrink: 0; cursor: pointer;">
            <img src="${product.image}" alt="${product.title}" style="width: 100%; height: 100%; object-fit: cover;" onerror="this.src='/placeholder.svg?height=${bestsellerImageSize.replace('px', '')}&width=${bestsellerImageSize.replace('px', '')}'">
          </div>
          <div class="bestseller-info clickable-area" data-url="${product.url}" style="flex: 1; text-align: left; min-width: 0; cursor: pointer;">
            <p style="margin: 0 0 ${mobile ? '2px' : '4px'} 0; font-size: ${mobile ? '12px' : '14px'}; color: #333; font-weight: 600; line-height: 1.2; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">${product.title}</p>
            <div style="margin: 0 0 ${mobile ? '6px' : '8px'} 0; display: flex; align-items: center; gap: ${mobile ? '4px' : '6px'};">
              <span style="font-size: ${mobile ? '13px' : '15px'}; font-weight: 700; color: #333;">${product.price}</span>
              <span style="font-size: ${mobile ? '11px' : '12px'}; color: #999; text-decoration: line-through;">${product.oldPrice}</span>
            </div>
            <button id="${buttonId}" data-variant-id="${product.id}" style="background: #333; color: white; border: none; padding: ${mobile ? '4px 10px' : '6px 14px'}; border-radius: 4px; font-size: ${mobile ? '10px' : '12px'}; cursor: pointer; font-weight: 600; transition: background 0.2s;">Ajouter</button>
          </div>
        </div>
      `;
    });
  }
  
  // Créer le cart drawer
  const cartDrawer = document.createElement('div');
  cartDrawer.className = 'custom-cart-drawer';
  cartDrawer.style.cssText = `
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    width: ${drawerWidth};
    background-color: #f8f9fa;
    box-shadow: -4px 0 20px rgba(0,0,0,0.15);
    z-index: 99999;
    transform: translateX(100%);
    transition: transform 0.3s ease;
    display: flex;
    flex-direction: column;
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
    overflow-y: auto;
  `;
  
  cartDrawer.innerHTML = `
    <!-- En-tête -->
    <div style="background: white; padding: ${headerPadding}; border-bottom: 1px solid #e9ecef; display: flex; justify-content: space-between; align-items: center; position: sticky; top: 0; z-index: 1;">
      <h2 style="margin: 0; font-size: ${mobile ? '16px' : '18px'}; font-weight: 700; color: #333;">VOTRE PANIER</h2>
      <button onclick="window.closeCustomCartDrawer()" style="background: none; border: 2px solid #333; border-radius: 50%; width: ${mobile ? '30px' : '35px'}; height: ${mobile ? '30px' : '35px'}; cursor: pointer; font-size: ${mobile ? '16px' : '18px'}; color: #333; display: flex; align-items: center; justify-content: center; transition: all 0.2s;">×</button>
    </div>
    
    <!-- Message de confiance -->
    <div style="background: #e9ecef; padding: ${mobile ? '8px 15px' : '12px 20px'}; text-align: center;">
      <p style="margin: 0; font-size: ${mobile ? '12px' : '14px'}; color: #666; font-weight: 500;">Rejoignez + de 3000 clients | 4.7/5</p>
    </div>
    
    <!-- Barre de progression livraison offerte -->
    <div style="background: white; padding: ${mobile ? '15px' : '20px'}; border-bottom: 1px solid #e9ecef;">
      <div style="position: relative; height: ${mobile ? '8px' : '10px'}; background: #e9ecef; border-radius: 5px; margin-bottom: ${mobile ? '10px' : '15px'}; overflow: hidden;">
        <div style="position: absolute; top: 0; left: 0; height: 100%; width: ${progressPercentage}%; background: linear-gradient(90deg, #92D8E0, #67c7d2); transition: width 0.5s ease; border-radius: 5px;"></div>
      </div>
      <p style="margin: 0; font-size: ${mobile ? '12px' : '14px'}; color: #333; text-align: center; font-weight: 500; line-height: 1.3;">
        ${freeShippingRemaining > 0 
          ? `Plus que <strong>${freeShippingRemaining.toFixed(2).replace('.', ',')}€</strong> pour bénéficier de la <strong>LIVRAISON OFFERTE!</strong>`
          : '<strong>🎉 Vous bénéficiez de la LIVRAISON OFFERTE!</strong>'
        }
      </p>
    </div>
    
    <!-- Produits du panier -->
    <div style="background: white; padding: ${itemPadding}; flex: 1; overflow-y: auto;">
      ${cartItemsHTML}
    </div>
    
    <!-- Best-sellers cliquables -->
    ${availableBestsellers.length > 0 ? `
    <div style="background: white; padding: ${mobile ? '10px 15px' : '15px 20px'}; border-top: 1px solid #e9ecef;">
      <h4 style="margin: 0 0 ${mobile ? '8px' : '12px'} 0; font-size: ${mobile ? '13px' : '15px'}; font-weight: 700; color: #333; text-align: center;">Découvrez nos best-sellers :</h4>
      <div style="position: relative; height: ${mobile ? '80px' : '120px'}; overflow: hidden;">
        <div class="bestsellers-container" style="display: flex; transition: transform 0.3s ease; height: 100%;">
          ${bestsellersHTML}
        </div>
        ${availableBestsellers.length > 1 ? `
        <button onclick="window.navigateBestsellers('prev')" style="position: absolute; left: ${mobile ? '2px' : '8px'}; top: 50%; transform: translateY(-50%); background: rgba(255,255,255,0.95); border: 1px solid #ddd; border-radius: 50%; width: ${mobile ? '28px' : '30px'}; height: ${mobile ? '28px' : '30px'}; cursor: pointer; display: flex; align-items: center; justify-content: center; box-shadow: 0 2px 8px rgba(0,0,0,0.15); z-index: 10; font-size: 0;">
          <svg width="${mobile ? '12' : '12'}" height="${mobile ? '12' : '12'}" viewBox="0 0 24 24" fill="none" stroke="#333" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <polyline points="15,18 9,12 15,6"></polyline>
          </svg>
        </button>
        <button onclick="window.navigateBestsellers('next')" style="position: absolute; right: ${mobile ? '2px' : '8px'}; top: 50%; transform: translateY(-50%); background: rgba(255,255,255,0.95); border: 1px solid #ddd; border-radius: 50%; width: ${mobile ? '28px' : '30px'}; height: ${mobile ? '28px' : '30px'}; cursor: pointer; display: flex; align-items: center; justify-content: center; box-shadow: 0 2px 8px rgba(0,0,0,0.15); z-index: 10; font-size: 0;">
          <svg width="${mobile ? '12' : '12'}" height="${mobile ? '12' : '12'}" viewBox="0 0 24 24" fill="none" stroke="#333" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <polyline points="9,18 15,12 9,6"></polyline>
          </svg>
        </button>
        ` : ''}
      </div>
    </div>
    ` : ''}
    
    <!-- Garantie -->
    <div style="background: white; padding: ${mobile ? '10px 15px' : '15px 20px'}; text-align: center; border-top: 1px solid #e9ecef;">
      <p style="margin: 0; font-size: ${mobile ? '12px' : '14px'}; color: #666;">Essayez sans risque : 30 jours satisfait ou remboursé</p>
    </div>
    
    <!-- Footer -->
    <div style="background: white; padding: ${mobile ? '15px' : '20px'}; border-top: 2px solid #e9ecef; margin-top: auto;">
      <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: ${mobile ? '12px' : '15px'};">
        <span style="font-size: ${mobile ? '16px' : '18px'}; font-weight: 700; color: #333;">Sous-total (${cart.item_count} article${cart.item_count > 1 ? 's' : ''})</span>
        <span style="font-size: ${mobile ? '18px' : '20px'}; font-weight: 700; color: #333;">${(cart.total_price / 100).toFixed(2).replace('.', ',')}€</span>
      </div>
      <button onclick="window.location.href='/checkout'" style="background: #92D8E0; color: white; border: none; padding: ${mobile ? '12px 15px' : '15px 20px'}; border-radius: 8px; width: 100%; font-weight: 700; cursor: pointer; font-size: ${mobile ? '14px' : '16px'}; display: flex; align-items: center; justify-content: center; gap: 8px; transition: background 0.2s;">
        <svg width="${mobile ? '14' : '16'}" height="${mobile ? '14' : '16'}" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect>
          <circle cx="12" cy="16" r="1"></circle>
          <path d="M7 11V7a5 5 0 0 1 10 0v4"></path>
        </svg>
        Passer ma commande
      </button>
    </div>
  `;
  
  // Ajouter au DOM
  document.body.appendChild(cartDrawer);
  
  // Créer l'overlay
  const overlay = document.createElement('div');
  overlay.className = 'custom-cart-overlay';
  overlay.style.cssText = `
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0,0,0,0.5);
    z-index: 99998;
    opacity: 0;
    transition: opacity 0.3s ease;
  `;
  document.body.appendChild(overlay);
  
  overlay.addEventListener('click', closeDrawerWithRefresh);
  
  // Animer l'ouverture
  setTimeout(() => {
    cartDrawer.style.transform = 'translateX(0)';
    overlay.style.opacity = '1';
  }, 10);
  
  // AJOUTER LES ÉCOUTEURS D'ÉVÉNEMENTS APRÈS CRÉATION DU DOM
  setTimeout(() => {
    // Gestion des clics sur les zones cliquables (redirection vers produit)
    const clickableAreas = document.querySelectorAll('.clickable-area');
    clickableAreas.forEach(area => {
      area.addEventListener('click', function(e) {
        const url = this.dataset.url;
        if (url) {
          console.log('🔗 Redirection vers:', url);
          window.location.href = url;
        }
      });
    });
    
    // Gestion des boutons d'ajout au panier
    availableBestsellers.forEach((product, index) => {
      const buttonId = `upsell-btn-${product.id}-${Date.now()}`;
      const button = document.getElementById(buttonId);
      if (button) {
        button.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopPropagation();
          console.log('🛒 Clic sur bouton upsell:', product.id);
          addBestsellerToCart(product.id, this);
        });
      }
    });
    
    // Alternative : Écouteur délégué sur le conteneur pour les boutons
    const bestsellerContainer = document.querySelector('.bestsellers-container');
    if (bestsellerContainer) {
      bestsellerContainer.addEventListener('click', function(e) {
        if (e.target.tagName === 'BUTTON' && e.target.dataset.variantId) {
          e.preventDefault();
          e.stopPropagation();
          console.log('🛒 Clic délégué sur bouton upsell:', e.target.dataset.variantId);
          addBestsellerToCart(e.target.dataset.variantId, e.target);
        }
      });
    }
  }, 100);
  
  // Fonction pour mettre à jour les quantités AVEC RÉOUVERTURE
  function updateQuantity(line, quantity) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity })
    })
    .then(response => response.json())
    .then(updatedCart => {
      const cartCountElements = document.querySelectorAll('.cart-count-bubble, .cart-count, [data-cart-count]');
      cartCountElements.forEach(element => {
        if (element.textContent !== undefined) {
          element.textContent = updatedCart.item_count;
        }
      });
      
      window.dispatchEvent(new CustomEvent('cart:updated', { detail: updatedCart }));
      
      // FERMER ET ROUVRIR LE DRAWER (pas de rafraîchissement ici)
      closeDrawerWithoutRefresh();
      setTimeout(() => {
        createCustomCartDrawer(updatedCart);
      }, 300);
    })
    .catch(error => {
      console.error('Erreur lors de la mise à jour:', error);
      alert('Erreur lors de la mise à jour du panier. Veuillez réessayer.');
    });
  }
  
  // Variables pour la navigation des best-sellers
  let currentBestsellerIndex = 0;
  const totalBestsellers = availableBestsellers.length;
  
  // Exposer les fonctions globalement
  window.updateCartQuantity = updateQuantity;
  
  window.navigateBestsellers = function(direction) {
    if (totalBestsellers <= 1) return;
    
    const bestsellerContainer = document.querySelector('.bestsellers-container');
    if (!bestsellerContainer) return;
    
    if (direction === 'prev') {
      currentBestsellerIndex = currentBestsellerIndex > 0 ? currentBestsellerIndex - 1 : totalBestsellers - 1;
    } else {
      currentBestsellerIndex = currentBestsellerIndex < totalBestsellers - 1 ? currentBestsellerIndex + 1 : 0;
    }
    
    const translateX = -currentBestsellerIndex * 100;
    bestsellerContainer.style.transform = `translateX(${translateX}%)`;
  };
  
  // FONCTION POUR AJOUTER LES UPSELLS AU PANIER AVEC RÉOUVERTURE
  function addBestsellerToCart(variantId, button) {
    console.log('🛒 Début ajout bestseller au panier:', variantId);
    
    if (!button) {
      console.error('❌ Bouton non trouvé');
      return;
    }
    
    const originalText = button.textContent;
    button.textContent = 'Ajout...';
    button.disabled = true;
    button.style.opacity = '0.7';
    button.style.cursor = 'not-allowed';
    
    // Préparer les données pour l'ajout au panier
    const formData = new FormData();
    formData.append('id', variantId);
    formData.append('quantity', '1');
    
    console.log('📦 Envoi de la requête d\'ajout au panier...');
    
    fetch('/cart/add.js', {
      method: 'POST',
      body: formData
    })
    .then(response => {
      console.log('📡 Réponse reçue:', response.status);
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      return response.json();
    })
    .then(data => {
      console.log('✅ Bestseller ajouté avec succès:', data);
      
      // Récupérer le panier mis à jour
      return fetch('/cart.js');
    })
    .then(response => {
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      return response.json();
    })
    .then(cart => {
      console.log('🛒 Panier mis à jour:', cart);
      
      // Mettre à jour tous les compteurs de panier
      const cartCountElements = document.querySelectorAll('.cart-count-bubble, .cart-count, [data-cart-count], .cart-icon span');
      cartCountElements.forEach(element => {
        if (element.textContent !== undefined) {
          element.textContent = cart.item_count;
        }
      });
      
      // Déclencher l'événement de mise à jour du panier
      window.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
      
      // FERMER ET ROUVRIR LE DRAWER (pas de rafraîchissement ici)
      closeDrawerWithoutRefresh();
      setTimeout(() => {
        createCustomCartDrawer(cart);
      }, 300);
    })
    .catch(error => {
      console.error('❌ Erreur lors de l\'ajout du bestseller:', error);
      
      // Restaurer le bouton en cas d'erreur
      button.textContent = originalText;
      button.disabled = false;
      button.style.opacity = '1';
      button.style.cursor = 'pointer';
      
      // Afficher un message d'erreur plus informatif
      alert(`Erreur lors de l'ajout au panier: ${error.message}. Veuillez réessayer.`);
    });
  }
  
  // Exposer la fonction globalement pour les événements inline (backup)
  window.addBestsellerToCart = addBestsellerToCart;
  
  // FERMETURE SANS RAFRAÎCHISSEMENT (pour les modifications de quantité)
  function closeDrawerWithoutRefresh() {
    console.log('🚪 Fermeture du drawer sans rafraîchissement');
    
    cartDrawer.style.transform = 'translateX(100%)';
    overlay.style.opacity = '0';
    
    setTimeout(() => {
      if (document.body.contains(cartDrawer)) document.body.removeChild(cartDrawer);
      if (document.body.contains(overlay)) document.body.removeChild(overlay);
      
      // Nettoyer les fonctions globales
      delete window.updateCartQuantity;
      delete window.navigateBestsellers;
      delete window.addBestsellerToCart;
      delete window.closeCustomCartDrawer;
    }, 300);
  }
  
  // FERMETURE AVEC RAFRAÎCHISSEMENT (pour la fermeture manuelle)
  function closeDrawerWithRefresh() {
    console.log('🚪 Fermeture du drawer avec rafraîchissement');
    
    cartDrawer.style.transform = 'translateX(100%)';
    overlay.style.opacity = '0';
    
    setTimeout(() => {
      if (document.body.contains(cartDrawer)) document.body.removeChild(cartDrawer);
      if (document.body.contains(overlay)) document.body.removeChild(overlay);
      
      // Nettoyer les fonctions globales
      delete window.updateCartQuantity;
      delete window.navigateBestsellers;
      delete window.addBestsellerToCart;
      delete window.closeCustomCartDrawer;
      
      // RAFRAÎCHIR LA PAGE POUR ÉVITER TOUT BLOCAGE
      console.log('🔄 Rafraîchissement de la page...');
      window.location.reload();
    }, 300);
  }
  
  window.closeCustomCartDrawer = closeDrawerWithRefresh;
}

window.openCustomCartDrawer = openCustomCartDrawer;
});
})();